/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedMeasurementUnitProvider_itemSearch$ref = any;
type SbSharedRefineMenuSearchWithin_itemSearch$ref = any;
export type SbRespAppliedFilters_itemSearch$ref = any;
export type SbRespAppliedFilters_itemSearch = {
    readonly totalResults: number | null;
    readonly filters: ReadonlyArray<{
        readonly name: string | null;
        readonly localizedFilterName: string | null;
        readonly values: ReadonlyArray<{
            readonly displayName: string | null;
            readonly urlLabel: string | null;
        } | null> | null;
    } | null> | null;
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly localizedFilterName: string | null;
        readonly canBeDismissed: boolean | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly displayName: string | null;
            readonly hexCode: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": SbSharedRefineMenuSearchWithin_itemSearch$ref & SbSharedMeasurementUnitProvider_itemSearch$ref;
    readonly " $refType": SbRespAppliedFilters_itemSearch$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "localizedFilterName",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "displayName",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "urlLabel",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "SbRespAppliedFilters_itemSearch",
        "type": "ItemSearchQueryConnection",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalResults",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "filters",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseFilter",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseFilterValue",
                        "plural": true,
                        "selections": [
                            (v2 /*: any*/),
                            (v3 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "appliedFilters",
                "storageKey": null,
                "args": null,
                "concreteType": "SearchBrowseParsedParam",
                "plural": true,
                "selections": [
                    (v0 /*: any*/),
                    (v1 /*: any*/),
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "canBeDismissed",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "plural": true,
                        "selections": [
                            (v3 /*: any*/),
                            (v2 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hexCode",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "SbSharedRefineMenuSearchWithin_itemSearch",
                "args": null
            },
            {
                "kind": "FragmentSpread",
                "name": "SbSharedMeasurementUnitProvider_itemSearch",
                "args": null
            }
        ]
    } as any;
})();
(node as any).hash = 'b910c1ebd74980d657db8d7b148e3527';
export default node;
